import type { ControllerFieldState, UseFormStateReturn } from 'react-hook-form';

import type { AddressFormValues } from '@/sections/address/types/AddressFormValues';

export const focusAndScroll = (
  ref: React.MutableRefObject<HTMLInputElement | null>
) => {
  ref.current?.focus();
  ref.current?.scrollIntoView({ behavior: 'smooth' });
};

export const getInputStatus = (
  formState: UseFormStateReturn<AddressFormValues>,
  fieldState: ControllerFieldState
) => {
  if (fieldState?.error?.message) return 'error';
  return (
    (formState.isSubmitted && (fieldState.invalid ? 'error' : 'validated')) ||
    undefined
  );
};
